import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Styles =styled.div`
    position: relative;
    .background {
        position: absolute;
        inset: 0;
        z-index: 0;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
        .overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg, #D9D9D900 0%, var(--body-1) 100%);
        }
    }
    .datas {
        /* color: #fff; */
        z-index: 1;
        width: 100%;
        grid-column: 2/7;
        text-align: right;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        justify-content: center;
        min-height: calc(100vh - 120px);
        .title {
            font-size: 1.5rem;
            font-weight: 600;
        }
        .desc {
            font-size: 1rem;
            font-weight: 400;
            text-align: justify;
        }
        .actions {
            display: flex;
            justify-content: flex-end;
            gap: 0.5rem;
            .btn {
                min-width: 200px;
            }
        }
    }
    @media screen and (max-width: 850px) {
        .datas {
            min-height: calc(100vh - 60px);
            width: 100%;
            grid-column: 2/6;
            justify-content: flex-end;
            .actions {
                margin: 2rem 0;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                gap: 0.5rem;
                .btn {
                    min-width: 200px;
                }
            }
        }
    }
`

const Intro1 =(props)=>{
    let object = {
        title: "text",
        desc: "text",
        btn: "text",
        image: "text",
    };
    if(props.data !== ""){
        object = JSON.parse(props.data)
    }
    return (
        <Styles className="main-grid">
            <div className="background">
                {
                    (window.innerWidth < 850) ? (
                        <img src={object.imagemobilesrc} alt={object.imagemoname}/>
                    ) : (
                        <img src={object.imagesrc} alt={object.imagename}/>
                    )
                }
                <div className="overlay"></div>
            </div>
            <div className="datas">
                <div className="title">
                    {object.title}
                </div>
                <div className="desc">
                    {object.description}
                </div>
                <div className="actions">
                    <Button 
                        className="btn"
                        color="primary" 
                        variant="contained" 
                        // style={{minWidth: "200px"}}
                        onClick={() => {
                            if(window.innerWidth < 850){
                                window.scrollTo({
                                    top: window.innerHeight,
                                    behavior: "smooth"
                                })
                            } else {
                                window.scrollTo({
                                    top: window.innerHeight - 60,
                                    behavior: "smooth"
                                })
                            }
                        }}
                    >
                        {object.button}
                    </Button>
                </div>
            </div>
        </Styles>
    )
}
export default Intro1